import axios from 'axios';
import {
  TRANSACTION_LIST_SUCCESS,
  TRANSACTION_LIST_ERROR,
  TRANSACTION_CLEAR_ALL,
  SET_CONVERSATION_ACTIVE_STATUS,
} from '../constants/ActionTypes';

export const fetchAllTransactions = () => (dispatch) => {
  const url = '/smarthelp/payment-activities';
  return axios
    .get(url)
    .then((response) =>
      dispatch({
        type: TRANSACTION_LIST_SUCCESS,
        payload: response.data.transactions,
      }),
    )
    .catch(() =>
      dispatch({
        type: TRANSACTION_LIST_ERROR,
      }),
    );
};

export const clearAllTransactions = () => (dispatch) => {
  dispatch({
    type: TRANSACTION_CLEAR_ALL,
  });
};

export const callTransactionBot = (transactionDetails) => (dispatch) => {
  const url = '/smarthelp/transaction-bot';
  return axios
    .post(url, {
      transactionDetails,
      _csrf: document.body.getAttribute('data-token'),
    })
    .then((response) => {
      if (response.data.conversationId) {
        window.nodeChat.showAsync(response.data.conversationId, {
          conversation: '',
          topicName: 'GENPOOL',
        });
      }
      dispatch({
        type: SET_CONVERSATION_ACTIVE_STATUS,
        payload: response.data.isConversationActive,
      });
    })
    .catch();
};
